var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rec{fill:#fff;}.d,.e{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}.e{stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rec",
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 5.5,
    y1: 17.5,
    x2: 5.5,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 4,
    y1: 6.14,
    x2: 7,
    y2: 6.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 10.5,
    y1: 17.5,
    x2: 10.5,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 9,
    y1: 14.14,
    x2: 12,
    y2: 14.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 15.5,
    y1: 17.5,
    x2: 15.5,
    y2: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 14,
    y1: 10.14,
    x2: 17,
    y2: 10.14
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/controls.283a72df5b5e496d08d6602a2a669620.svg";
export { ForwardRef as ReactComponent };